import mixpanel from "mixpanel-browser";

import { getRequestOrigin } from "../utils/requestOrigin";

import { mixpanelCallback } from "./utils/mixpanelCallback";

import type { Callback, RequestOptions } from "mixpanel-browser";

let initialized = false;
let analyticsReady = false;

export function initAnalytics(): void {
  const token = import.meta.env.VITE_MIXPANEL_ID;
  const apiHost = import.meta.env.VITE_MIXPANEL_API_HOST;
  const analyticsEnabled = import.meta.env.VITE_ENABLE_ANALYTICS === "true";
  if (!token || !apiHost || !analyticsEnabled) return;

  mixpanel.init(token, {
    api_host: apiHost,
    cross_subdomain_cookie: false,
  });
  initialized = true;
}

export function trackEvent(
  event: string,
  properties?: Record<string, unknown>,
  optionsOrCallback?: Callback | RequestOptions,
): void {
  if (!analyticsReady) return;

  if (import.meta.env.DEV) {
    console.log("[mixpanel]", event, {
      product: getRequestOrigin(),
      ...properties,
    });
  }

  // Every app posts to one Mixpanel project and shares the mp_ cookie under
  // one host, so the app identity rides on each event rather than a super
  // property, which the last-registered app would otherwise own for all tabs.
  mixpanel.track(
    event,
    { product: getRequestOrigin(), ...properties },
    optionsOrCallback,
    (response) => mixpanelCallback(response, event),
  );
}

export function trackIdentity(distinctId: string): void {
  if (!initialized) return;
  mixpanel.identify(distinctId);
  analyticsReady = true;
}

export function trackUserProperties(properties: Record<string, unknown>): void {
  if (!analyticsReady) return;
  mixpanel.people.set(properties);
}

export function resetAnalytics(): void {
  analyticsReady = false;
  if (!initialized) return;
  mixpanel.reset();
}
